import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import db from "../../db/index.json";
import LabelTag from "../reusebale/label";
import ParagraphTag from "../reusebale/Paragraph";
import ButtonTag from "../reusebale/button";
import { EyeOff, Eye } from "lucide-react";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import { ShowError } from "../../utils/ToasFunction";
import { useSelector, useDispatch } from "react-redux";
import {
  saveLoginData,
  saveUserCredentials,
  clearUserCredentials,
  clearLoginData,
  getStoredUserCredentials,
} from "../../utils/storageUtils";

import MyLoader from "../reusebale/MyLoader";
const FormSection = () => {
  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [remember, setRemember] = useState(false);

  const { login } = db;

  const [formFields, setFormFields] = useState({
    email: "",
    password: "",
  });
  const SaveDataToLocal = (data) => {
    saveLoginData(data);
  };

  function saveCredentialsToLocalStorage(email, password) {
    saveUserCredentials(email, password);
  }

  useEffect(() => {
    const GetUserInfo = () => {
      const credentials = getStoredUserCredentials();
      if (credentials) {
        setFormFields((prev) => ({
          ...prev,
          email: credentials.email,
          password: credentials.password,
        }));
        setRemember(true);
      }
    };
    GetUserInfo();
  }, []);

  useEffect(() => {
    if (loginSuccess) {
      if (remember) {
        saveCredentialsToLocalStorage(formFields.email, formFields.password);
        SaveDataToLocal(loginSuccess);
      } else {
        clearUserCredentials();
        clearLoginData(); // Also clear any existing login data
      }
      setFormFields((prev) => ({
        ...prev,
        email: "",
        password: "",
      }));
      navigate("/dashboard");
    } else if (loginError?.data?.email) {
      navigate("/account-verification");
    } else {
      ShowError(loginError?.message);
    }
  }, [
    loginSuccess,
    loginError,
    remember,
    // formFields.email,
    // formFields.password,
    navigate,
  ]);
  const loginHandler = (e) => {
    e.preventDefault();

    if (formFields.email === "") {
      ShowError("Please enter your email address first");
    } else if (formFields.password === "") {
      ShowError("Please enter your password first");
    } else {
      dispatch(AuthAction.UserLogInAction(formFields));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form>
      <div class="w-full mt-3">
        <LabelTag name={login.emailLabel} />
        <input
          value={formFields.email}
          onChange={(e) => {
            setFormFields((prev) => ({
              ...prev,
              email: e.target.value,
            }));
          }}
          type="text"
          placeholder="Enter your email.."
          className="w-full mt-1 text-sm font-popinsRegular bg-bgColor px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
        />
      </div>
      <div className="w-full mt-3">
        <LabelTag name={login.passLabel} />
        <div className="relative">
          <input
            value={formFields.password}
            onChange={(e) => {
              setFormFields((prev) => ({
                ...prev,
                password: e.target.value,
              }));
            }}
            type={showPassword ? "text" : "password"}
            placeholder="Password here.."
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          />
          <div
            title={!showPassword ? "Show password" : "Hide password"}
            className="absolute right-3 top-3 text-stone-950/40 cursor-pointer"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </div>
        </div>
      </div>
      <div className="flex justify-between mt-3 ">
        <div className="flex w-[50%]">
          <input
            checked={remember}
            onChange={(e) => {
              setRemember(e.target.checked);
            }}
            type="checkbox"
            className="w-4 bg-bgColor rounded-lg cursor-pointer"
          />
          <ParagraphTag
            content={login.remember}
            classes="text-[#686868] text-sm pl-3 font-popinsRegular"
          />
        </div>
        {/* <div className="w-[50%] flex justify-end">
          <ParagraphTag content={login.forgetPass} classes='text-themeColor text-sm font-popinsMedium cursor-pointer' />
        </div> */}
      </div>
      {loader ? (
        <div className="flex justify-center items-center">
          <MyLoader />
        </div>
      ) : (
        <ButtonTag
          onSubmit={loginHandler}
          name={login.SubmitBtn}
          classes="text-base bg-themeColor hover:bg-themeColor/90 mt-3 text-center  text-white"
        />
      )}
    </form>
  );
};

export default FormSection;
